import { Injectable } from '@angular/core';
import { TelemetryProvider } from '../models/telemetry-provider';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { TelemetryErrorEvent } from '../models/telemetry-error-event';
import { TelemetryPageViewEvent } from '../models/telemetry-page-view-event';
import { TelemetryEvent } from '../models/telemetry-event';
import { AppConfigService } from '../../../services/app-config.service';

@Injectable({
	providedIn: 'root'
})
export class CloudwatchTelemetryProvider extends TelemetryProvider {
	private http: HttpClient = new HttpClient(new HttpXhrBackend({
		build: () => new XMLHttpRequest()
	}));

	constructor(private appConfig: AppConfigService) {
		super();
	}

	trackError(event: TelemetryErrorEvent): void {
		event.context.stack = event.stack;
		event.context.internalError = event.internalError;
		const body = {
			type: 'error',
			context: event.context
		} as TelemetryEventResource;

		this.http.post<string>(`${this.appConfig.getConfig().webApi2}/api2/telemetry/events`, [body]).subscribe();
	}

	trackEvent(event: TelemetryEvent): void {
		const body = {
			type: 'event',
			context: event.context,
			name: event.name
		} as TelemetryEventResource;

		this.http.post<string>(`${this.appConfig.getConfig().webApi2}/api2/telemetry/events`, [body]).subscribe();
	}

	trackPageView(event: TelemetryPageViewEvent): void {
		event.context.page = event.page;
		const body = {
			type: 'event',
			context: event.context,
			name: event.name
		} as TelemetryEventResource;

		this.http.post<string>(`${this.appConfig.getConfig().webApi2}/api2/telemetry/events`, [body]).subscribe();
	}
}

interface TelemetryEventResource {
	name: string;
	type: 'event' | 'error';
	context: any;
}
